import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ImportWizardRoute,
  ImportWizardPathName,
} from '@/modules/ta/importwizard/importwizard.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}`,
      name: ImportWizardPathName.IMPORTWIZARD,
      component: () =>
        import(
          /* webpackChunkName: "importwizards-page" */ '@/modules/ta/importwizard/pages/ImportWizardsPage.vue'
        ),
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/manageuploads/:id`,
      name: ImportWizardPathName.IMPORTWIZARDMANAGEUPLOADS,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-delete-data-page" */ './pages/ImportWizardManageUploadedFilesPage.vue'
        ),
      props: true,
    },

    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/angular/new`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/angular/clone/:id`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_CLONE,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/angular/:id?`,
      name: ImportWizardPathName.IMPORTWIZARDFORM,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/clone/:id`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_VUE_CLONE,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/ta/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/angular/:parent_id/sub/:id`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_SUB,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/:parent_id/sub/new`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_VUE_SUB_NEW,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/ta/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/:parent_id/sub/:id`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_VUE_SUB,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/ta/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/new`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_VUE_NEW,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-sublevel-page-vue" */ '@/modules/ta/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/:id?`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_VUE,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-sublevel-page-vue" */ '@/modules/ta/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/:id/emails`,
      name: ImportWizardPathName.IMPORTWIZARD_EMAILS,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-emails-page" */ './pages/ImportWizardEmailsPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/detail/:id?`,
      redirect: (to) => `/${ImportWizardRoute.IMPORTWIZARD}/${to.params.id}`,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/detail/:parent_id/sub/:id`,
      redirect: (to) =>
        `/${ImportWizardRoute.IMPORTWIZARD}/${to.params.parent_id}/sub/${to.params.id}`,
    },
  ],
  Module.IMPORTWIZARD
);
